<template>
  <v-app-bar dark>
    Consultation des VL Casino
    <v-spacer></v-spacer>
    {{ code + " - " + currentCompany + " - " + currentWarehouse }}
    <v-btn fab @click="handleLogout" app text>
      <v-icon large>mdi-logout</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
import Vue from "vue";
import { mapActions, mapState } from "vuex";
export default {
  name: "app-header",

  data() {
    return {};
  },
  computed: {
    ...mapState("userContext", ["currentCompany", "code", "currentWarehouse"])
  },
  methods: {
    ...mapActions("userContext", ["logout"]),
    handleLogout() {
      const redirectUri = this.$route.fullPath;
      this.logout()
        .then(this.$router.push({ name: "login", query: { redirectUri: redirectUri } }))
        .catch(error => {
          //TODO : ajouter un message d'erreur sur la page
          Vue.$log.error(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "app-header.scss";
</style>
